<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div
    *ngIf="
      executiveAssociatePhoneNumberAudits && executiveAssociatePhoneNumberAudits.length > 0;
      else noAudits
    "
  >
    <sd-portal-audit-detail-list
      [audits]="executiveAssociatePhoneNumberAudits"
      (nextPage)="onNextPage()"
    >
    </sd-portal-audit-detail-list>
  </div>

  <ng-template #noAudits> No Executive Admin Phone Number audits </ng-template>
</ng-template>
